import FindInPage from '@material-ui/icons/FindInPage';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import React from 'react';
import { NavLink } from 'react-router-dom';
import * as constants from 'app-constants';

export default function ListAuditLogs(props) {
  const { listItemClass, listItemTextClass, listIcon } = props;

  return (
    <>
      <ListItem
        button
        component={NavLink}
        to={{ pathname: constants.PATH_AUDIT_LOGS }}
        className={listItemClass}
        activeClassName="selected"
      >
        <ListItemIcon className={listIcon}>
          <FindInPage />
        </ListItemIcon>
        <ListItemText primary="Audit Logs" className={listItemTextClass} />
      </ListItem>
    </>
  );
}
